import { render, staticRenderFns } from "./GenericFaq.vue?vue&type=template&id=3d4eb7ef&scoped=true"
import script from "./GenericFaq.vue?vue&type=script&lang=js"
export * from "./GenericFaq.vue?vue&type=script&lang=js"
import style0 from "./GenericFaq.vue?vue&type=style&index=0&id=3d4eb7ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4eb7ef",
  null
  
)

export default component.exports